import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import { editModeOn } from "../../../../utilFunctions";
import { functionalities, INVESTIGATION_TYPES, RISK } from "../../../../consts";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import Select from 'react-select';
import "./investigation.scss";
import { requestInvestigation, fetchInvestigationOptions } from "./investigationHelper";
import CloseInvestigationForm from "./CloseInvestigationForm";

const InvestigationRequest = (props) => {
  const {
    modalData,
    claimDetails,
    setNotified,
    requestButtonText,
    mode,
    onClose,
    investigationLists,
    roleDataCookie
  } = props;

  const [showRequestForm, setShowRequestForm] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const [triggerOptions, setTriggerOptions] = useState([]);

  const [notifyPayload, setNotifyPayload] = useState({
    claimIntimationNumber: claimDetails?.claimId,
    triggerInvestigation: '',
    reasonForInvestigation: '',
    investigatorMobile: '',
    createdBy: '',
  });

  useEffect(() => {
    const getTriggerOptions = async () => {
      setLoadingOptions(true);
      const data = await fetchInvestigationOptions();
      if (Array.isArray(data)) {
        const formattedOptions = data.map(item => ({
          value: item.id,
          label: item.reason,
        }));
        setTriggerOptions(formattedOptions);
      }
      setLoadingOptions(false);
    };

    getTriggerOptions();
  }, []);

  const toggleRequestReview = () => {
    if (investigationLists?.every((investigation)=>{ return investigation?.investigationStatus.toLowerCase()  === 'closed'})) {
      setShowRequestForm(true);
    }
  }

  const submitRequestInvestigation = async () => {
    if (!notifyPayload.triggerInvestigation) {
      toast.error("Please select a Trigger for Investigation.");
      return;
    }
    if (!notifyPayload.reasonForInvestigation) {
      toast.error("Please enter the Reason for Investigation.");
      return;
    }

    setLoadingRequest(true);
    try {
      const payload = {
        triggeredReason: notifyPayload.triggerInvestigation, // now sending ID
        reasonForInvestigation: notifyPayload.reasonForInvestigation,
        mobileNo: notifyPayload.investigatorMobile,
        investigationType: INVESTIGATION_TYPES.GENERAL,
        investigationRequestedBy:roleDataCookie?.emailID
      };

      const response = await requestInvestigation(claimDetails?.claimId, payload);

      if (response) {
        toast.success("Investigation request submitted successfully!");
        setNotified(true);
        setShowRequestForm(false);
        setNotifyPayload({
          ...notifyPayload,
          triggerInvestigation: "",
          reasonForInvestigation: "",
          investigatorMobile: "",
        });
      } else {
        toast.error("Failed to submit investigation request.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting the request.");
    } finally {
      setLoadingRequest(false);
    }
  };

  const clearData = () => {
    setShowRequestForm(false);
    setNotifyPayload({
      ...notifyPayload,
      triggerInvestigation: "",
      reasonForInvestigation: "",
      investigatorMobile: "",
    });
    if (onClose) onClose();
  };

  const renderFormContent = () => {
    if (mode === 'close') {
      return (
        <CloseInvestigationForm
          onClose={onClose}
          // updateClaimSubstatus={updateClaimSubstatus}
          claimDetails={claimDetails}
          modalData={modalData}
        />
      );
    }

    const isSubmitDisabled = !notifyPayload.triggerInvestigation || !notifyPayload.reasonForInvestigation;

    return (
      <>
        <h4 className="form-heading">Request New Investigation</h4>

        <div className="form-group">
          <label className="form-label">
            Trigger Investigation <AsteriskSymbol />
          </label>
          {loadingOptions ? (
            <div>Loading trigger options...</div>
          ) : (
            <Select
              options={triggerOptions}
              value={triggerOptions.find(option => option.value === notifyPayload.triggerInvestigation)}
              onChange={(selectedOption) =>
                setNotifyPayload({
                  ...notifyPayload,
                  triggerInvestigation: selectedOption?.value || "",
                })
              }
              placeholder="Select Trigger"
              isClearable
            />
          )}
        </div>

        {/* <div className="form-group">
          <label className="form-label">Investigator Mobile Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Mobile Number"
            value={notifyPayload.investigatorMobile}
            maxLength={10}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, '');
              setNotifyPayload({
                ...notifyPayload,
                investigatorMobile: numericValue,
              });
            }}
          />
        </div> */}

        <div className="form-group">
          <label className="form-label">
            Reason for Investigation <AsteriskSymbol />
          </label>
          <textarea
            className="form-control"
            placeholder="Enter reason for investigation"
            value={notifyPayload.reasonForInvestigation}
            maxLength={600}
            onChange={(e) =>
              setNotifyPayload({
                ...notifyPayload,
                reasonForInvestigation: e.target.value,
              })
            }
          />
          <div className="text-end small text-muted">
            {notifyPayload.reasonForInvestigation.length}/600 characters
          </div>
        </div>

        <div className="d-flex justify-content-center gap-4">
          <button className="btn btn-outline-success" onClick={clearData}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={submitRequestInvestigation}
            disabled={isSubmitDisabled}
          >
            Submit
          </button>
        </div>
      </>
    );
  };

  return (
    <>
      {(roleDataCookie?.roleName == "Admin" || (editModeOn(functionalities.INVESTIGATION_TAB) && roleDataCookie?.roleName === RISK)) && !mode && (
        <div
          onClick={toggleRequestReview}
          className={investigationLists?.every((investigation)=>{ return investigation?.investigationStatus.toLowerCase() === 'closed'}) ? "requestCalc fw-bold" : "requestCalc fw-bold bg-secondary"}
        >
          {requestButtonText ? requestButtonText : "Request Investigation"}
        </div>
      )}
      {(showRequestForm || mode) && (
        <div id="modal-overlay" className="text-start">      
          {loadingRequest && <LoadingPage kshemaLoader />}
           {!loadingRequest && (
            <div className="field-survey-form">
              <div className="overlay-text-calc text-right me-3">
                <span
                  type="button"
                  onClick={clearData}
                  className="close"
                  aria-label="Close"
                >
                </span>
              </div>
              <div className="form-content-wrapper">{renderFormContent()}</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InvestigationRequest;